import {FC} from 'react';

import {Text} from 'components/Text/Text';

import styles from './SelectItemCompany.module.css';

type Props = {
    title: string;
    inn?: string;
};
export const SelectItemCompany: FC<Props> = ({title, inn}) => {
    return (
        <div className={styles.block}>
            <Text.Bold14 className={styles.title}>{title}</Text.Bold14>
            {inn && (
                <Text.Regular14 className={styles.inn}>
                    (ИНН: {inn})
                </Text.Regular14>
            )}
        </div>
    );
};
